import { ErrorMessage, Field } from "formik";

type Props = {
    label: string;
    name: string;
    type: string;
    placeholder: string;
    children?: React.ReactElement;
    [x: string]: any;
}

const LoginInput = (props: Props) => {
    const { label, name, type = "text", placeholder, children, ...rest } = props;

    return (
        <div className="form-group">
            <div className="mg-b-4 d-flex justify-content-between align-items-center">
                <label className="form-label mg-b-0">
                    {label}
                </label>
                {children}
            </div>

            <Field
                type={type}
                className="form-control"
                name={name}
                placeholder={placeholder}
                {...rest}
            />

            <ErrorMessage name={name} render={msg => <span className="text-danger">{msg}</span>} />
        </div>
    )
}

export default LoginInput